import { getDefaultClient } from '@arcubase/client-ts'
import type {
  OAuthTokenReqVO,
  OAuthTokenRespVO
} from '@arcubase/client-ts'
import type {
  OAuthGetAuthorizeCodeReqVO,
  OAuthGetAuthorizeCodeRespVO,
  OAuthClientInfoRespVO
} from '@arcubase/client-ts'

// @endpoint POST /open/api/oauth/token
export async function getOAuthToken(
  data: OAuthTokenReqVO
): Promise<OAuthTokenRespVO> {
  return getDefaultClient().post('/open/api/oauth/token', data)
}

// @endpoint GET /api/oauth/client-info/:client_id
export async function getOAuthClientInfo(
  clientId: string
): Promise<OAuthClientInfoRespVO> {
  return getDefaultClient().get(`/oauth/client-info/${clientId}`)
}

// @endpoint POST /api/oauth/get-authorize-code
export async function getOAuthAuthorizeCode(
  data: OAuthGetAuthorizeCodeReqVO
): Promise<OAuthGetAuthorizeCodeRespVO> {
  return getDefaultClient().post('/oauth/get-authorize-code', data)
}

